module.exports = __webpack_public_path__ + "img/arrow-right-small.7e2af1ac.svg";